import { useEffect,useState } from "react";
import ReactDOM from "react-dom";

const portalRoot = document.getElementsByTagName("body")[0];


const Portal = ({ children }) => {
    const [portalContainerElement]=useState(document.createElement("div"))
  
    useEffect(() => {
        return () => {
            //unmount
            portalRoot.removeChild(portalContainerElement);
        }
    },[])

    useEffect(() => {
        //mount
        portalRoot.appendChild(portalContainerElement);
    },[])


    

    return ReactDOM.createPortal(children, portalContainerElement);
}

export default Portal;
